import PropTypes from 'prop-types';
import { recurrenceTypes } from '../../settings/constants';

const RecurrencePatern = PropTypes.shape({
  recurEvery: PropTypes.number,
  recurrenceType: PropTypes.string,
  selectedDays: PropTypes.objectOf(PropTypes.objectOf(PropTypes.bool)),
  dateTo: PropTypes.string,
  dateFrom: PropTypes.string,
  specificTimeFrom: PropTypes.string,
});

const RecurrencePatternDefaultValues = {
  recurEvery: 1,
  recurrenceType: recurrenceTypes.DAILY,
  dateTo: undefined,
  dateFrom: undefined,
  specificTimeFrom: undefined,
  selectedDays: undefined,
};

export { RecurrencePatern, RecurrencePatternDefaultValues };
